import Vue from "vue";
import Router from "vue-router";
import CanvasMain from "./views/CanvasMain.vue";
import Tablet from "./views/Tablet";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: CanvasMain
    },
    {
      path: "/tablet",
      name: "tablet",
      component: Tablet
    }
    // ,
    // {
    //   path: "/about",
    //   name: "about",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/About.vue")
    // }
  ]
});
